import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Home as HomeIcon } from "lucide-react";

export function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex items-center justify-center bg-[#FAF7F2] px-6 pt-32 pb-24 relative overflow-hidden"
    >
      <div className="blob-amber -top-40 -left-40" />
      <div className="blob-navy -bottom-40 -right-40" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative max-w-2xl text-center"
      >
        <p className="text-xs uppercase tracking-[0.25em] text-[#E9610E] font-semibold mb-4">
          Error 404
        </p>
        <h1 className="font-display font-extrabold text-6xl sm:text-8xl lg:text-9xl leading-[0.95] tracking-tighter text-[#0F1E3C]">
          Lost in <span className="italic font-serif gradient-text-amber">transit.</span>
        </h1>
        <p className="mt-8 text-lg text-[#475569] leading-relaxed max-w-lg mx-auto">
          The page you&rsquo;re looking for doesn&rsquo;t exist — but the right role or the right hire probably does.
          Let&rsquo;s get you back on track.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" data-testid="notfound-home" className="btn-primary">
            <HomeIcon className="w-4 h-4" /> Back home
          </Link>
          <Link to="/careers" data-testid="notfound-careers" className="btn-outline">
            Browse open roles <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
